import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import AdminUsers from './AdminUsers.vue'
import SharedRuns from './SharedRuns.vue'
import SharedRunShow from './SharedRunShow.vue'
import Competitions from './Competitions.vue'
import CompetitionShow from './CompetitionShow.vue'
import Shops from './Shops.vue'
import ShopShow from './ShopShow.vue'
import Coaches from './Coaches.vue'
import CoachShow from './CoachShow.vue'
import SplitCalculator from './SplitCalculator.vue'
import CookiePolicy from './CookiePolicy.vue'
import DataDeletion from './DataDeletion.vue'
import PrivacyPolicy from './PrivacyPolicy.vue'
import News from './News.vue'
import NewsShow from './NewsShow.vue'
import NewsForm from './NewsForm.vue'
import Forum from './Forum.vue'
import ForumTopic from './ForumTopic.vue'
import Conversations from './Conversations.vue'
import ConversationShow from './ConversationShow.vue'
import UserSidebar from './UserSidebar.vue'

function createI18nInstance(el) {
  const locale = el.dataset.locale || 'ro'
  const translations = JSON.parse(el.dataset.translations || '{}')

  return createI18n({
    legacy: false,
    locale,
    fallbackLocale: 'ro',
    messages: translations
  })
}

function mountVueApps() {
  // Home page
  const homeEl = document.getElementById('vue-app')
  if (homeEl && !homeEl.__vue_app__) {
    const app = createApp(App, {
      signedIn: homeEl.dataset.signedIn === 'true',
      userName: homeEl.dataset.userName || '',
      userAdmin: homeEl.dataset.userAdmin === 'true',
      news: JSON.parse(homeEl.dataset.news || '[]'),
      topTopics: JSON.parse(homeEl.dataset.topTopics || '[]'),
      todayRuns: JSON.parse(homeEl.dataset.todayRuns || '[]'),
      upcomingCompetitions: JSON.parse(homeEl.dataset.upcomingCompetitions || '[]'),
      csrfToken: homeEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(homeEl))
    app.mount(homeEl)
  }

  // Admin users page
  const adminUsersEl = document.getElementById('vue-admin-users')
  if (adminUsersEl && !adminUsersEl.__vue_app__) {
    const app = createApp(AdminUsers, {
      userEmail: adminUsersEl.dataset.userEmail || '',
      users: JSON.parse(adminUsersEl.dataset.users || '[]'),
      csrfToken: adminUsersEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(adminUsersEl))
    app.mount(adminUsersEl)
  }

  // Shared runs page
  const sharedRunsEl = document.getElementById('vue-shared-runs')
  if (sharedRunsEl && !sharedRunsEl.__vue_app__) {
    const app = createApp(SharedRuns, {
      signedIn: sharedRunsEl.dataset.signedIn === 'true',
      userName: sharedRunsEl.dataset.userName || '',
      userId: parseInt(sharedRunsEl.dataset.userId) || null,
      userAdmin: sharedRunsEl.dataset.userAdmin === 'true',
      sharedRuns: JSON.parse(sharedRunsEl.dataset.sharedRuns || '[]'),
      csrfToken: sharedRunsEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(sharedRunsEl))
    app.mount(sharedRunsEl)
  }

  // Shared run show page
  const sharedRunShowEl = document.getElementById('vue-shared-run-show')
  if (sharedRunShowEl && !sharedRunShowEl.__vue_app__) {
    const app = createApp(SharedRunShow, {
      signedIn: sharedRunShowEl.dataset.signedIn === 'true',
      userName: sharedRunShowEl.dataset.userName || '',
      userId: parseInt(sharedRunShowEl.dataset.userId) || null,
      userAdmin: sharedRunShowEl.dataset.userAdmin === 'true',
      sharedRun: JSON.parse(sharedRunShowEl.dataset.sharedRun || '{}'),
      csrfToken: sharedRunShowEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(sharedRunShowEl))
    app.mount(sharedRunShowEl)
  }

  // Competitions index
  const competitionsEl = document.getElementById('vue-competitions')
  if (competitionsEl && !competitionsEl.__vue_app__) {
    const app = createApp(Competitions, {
      signedIn: competitionsEl.dataset.signedIn === 'true',
      userName: competitionsEl.dataset.userName || '',
      userId: parseInt(competitionsEl.dataset.userId) || null,
      userAdmin: competitionsEl.dataset.userAdmin === 'true',
      competitions: JSON.parse(competitionsEl.dataset.competitions || '[]'),
      csrfToken: competitionsEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(competitionsEl))
    app.mount(competitionsEl)
  }

  // Competition show
  const competitionShowEl = document.getElementById('vue-competition-show')
  if (competitionShowEl && !competitionShowEl.__vue_app__) {
    const app = createApp(CompetitionShow, {
      signedIn: competitionShowEl.dataset.signedIn === 'true',
      userName: competitionShowEl.dataset.userName || '',
      userId: parseInt(competitionShowEl.dataset.userId) || null,
      userAdmin: competitionShowEl.dataset.userAdmin === 'true',
      competition: JSON.parse(competitionShowEl.dataset.competition || '{}'),
      csrfToken: competitionShowEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(competitionShowEl))
    app.mount(competitionShowEl)
  }
  // Shops index
  const shopsEl = document.getElementById('vue-shops')
  if (shopsEl && !shopsEl.__vue_app__) {
    const app = createApp(Shops, {
      signedIn: shopsEl.dataset.signedIn === 'true',
      userName: shopsEl.dataset.userName || '',
      userId: parseInt(shopsEl.dataset.userId) || null,
      userAdmin: shopsEl.dataset.userAdmin === 'true',
      shops: JSON.parse(shopsEl.dataset.shops || '[]'),
      csrfToken: shopsEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(shopsEl))
    app.mount(shopsEl)
  }

  // Shop show
  const shopShowEl = document.getElementById('vue-shop-show')
  if (shopShowEl && !shopShowEl.__vue_app__) {
    const app = createApp(ShopShow, {
      signedIn: shopShowEl.dataset.signedIn === 'true',
      userName: shopShowEl.dataset.userName || '',
      userId: parseInt(shopShowEl.dataset.userId) || null,
      userAdmin: shopShowEl.dataset.userAdmin === 'true',
      shop: JSON.parse(shopShowEl.dataset.shop || '{}'),
      csrfToken: shopShowEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(shopShowEl))
    app.mount(shopShowEl)
  }
  // News index
  const newsEl = document.getElementById('vue-news')
  if (newsEl && !newsEl.__vue_app__) {
    const app = createApp(News, {
      signedIn: newsEl.dataset.signedIn === 'true',
      userName: newsEl.dataset.userName || '',
      userId: parseInt(newsEl.dataset.userId) || null,
      userAdmin: newsEl.dataset.userAdmin === 'true',
      news: JSON.parse(newsEl.dataset.news || '[]'),
      csrfToken: newsEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(newsEl))
    app.mount(newsEl)
  }

  // News show
  const newsShowEl = document.getElementById('vue-news-show')
  if (newsShowEl && !newsShowEl.__vue_app__) {
    const app = createApp(NewsShow, {
      signedIn: newsShowEl.dataset.signedIn === 'true',
      userName: newsShowEl.dataset.userName || '',
      userId: parseInt(newsShowEl.dataset.userId) || null,
      userAdmin: newsShowEl.dataset.userAdmin === 'true',
      newsItem: JSON.parse(newsShowEl.dataset.newsItem || '{}'),
      comments: JSON.parse(newsShowEl.dataset.comments || '[]'),
      csrfToken: newsShowEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(newsShowEl))
    app.mount(newsShowEl)
  }

  // News form (new/edit)
  const newsFormEl = document.getElementById('vue-news-form')
  if (newsFormEl && !newsFormEl.__vue_app__) {
    const app = createApp(NewsForm, {
      signedIn: newsFormEl.dataset.signedIn === 'true',
      userName: newsFormEl.dataset.userName || '',
      newsItem: JSON.parse(newsFormEl.dataset.newsItem || '{}'),
      editing: newsFormEl.dataset.editing === 'true',
      csrfToken: newsFormEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(newsFormEl))
    app.mount(newsFormEl)
  }

  // Forum index
  const forumEl = document.getElementById('vue-forum')
  if (forumEl && !forumEl.__vue_app__) {
    const app = createApp(Forum, {
      signedIn: forumEl.dataset.signedIn === 'true',
      userName: forumEl.dataset.userName || '',
      userId: parseInt(forumEl.dataset.userId) || null,
      userAdmin: forumEl.dataset.userAdmin === 'true',
      topics: JSON.parse(forumEl.dataset.topics || '[]'),
      csrfToken: forumEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(forumEl))
    app.mount(forumEl)
  }

  // Forum topic show
  const forumTopicEl = document.getElementById('vue-forum-topic')
  if (forumTopicEl && !forumTopicEl.__vue_app__) {
    const app = createApp(ForumTopic, {
      signedIn: forumTopicEl.dataset.signedIn === 'true',
      userName: forumTopicEl.dataset.userName || '',
      userId: parseInt(forumTopicEl.dataset.userId) || null,
      userAdmin: forumTopicEl.dataset.userAdmin === 'true',
      topic: JSON.parse(forumTopicEl.dataset.topic || '{}'),
      messages: JSON.parse(forumTopicEl.dataset.messages || '[]'),
      csrfToken: forumTopicEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(forumTopicEl))
    app.mount(forumTopicEl)
  }

  // Conversations index
  const conversationsEl = document.getElementById('vue-conversations')
  if (conversationsEl && !conversationsEl.__vue_app__) {
    const app = createApp(Conversations, {
      signedIn: conversationsEl.dataset.signedIn === 'true',
      userName: conversationsEl.dataset.userName || '',
      userId: parseInt(conversationsEl.dataset.userId) || null,
      conversations: JSON.parse(conversationsEl.dataset.conversations || '[]'),
      csrfToken: conversationsEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(conversationsEl))
    app.mount(conversationsEl)
  }

  // Conversation show
  const conversationShowEl = document.getElementById('vue-conversation-show')
  if (conversationShowEl && !conversationShowEl.__vue_app__) {
    const app = createApp(ConversationShow, {
      signedIn: conversationShowEl.dataset.signedIn === 'true',
      userName: conversationShowEl.dataset.userName || '',
      userId: parseInt(conversationShowEl.dataset.userId) || null,
      conversationId: parseInt(conversationShowEl.dataset.conversationId) || null,
      otherUser: JSON.parse(conversationShowEl.dataset.otherUser || '{}'),
      messages: JSON.parse(conversationShowEl.dataset.messages || '[]'),
      csrfToken: conversationShowEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(conversationShowEl))
    app.mount(conversationShowEl)
  }

  // Coaches index
  const coachesEl = document.getElementById('vue-coaches')
  if (coachesEl && !coachesEl.__vue_app__) {
    const app = createApp(Coaches, {
      signedIn: coachesEl.dataset.signedIn === 'true',
      userName: coachesEl.dataset.userName || '',
      userId: parseInt(coachesEl.dataset.userId) || null,
      userAdmin: coachesEl.dataset.userAdmin === 'true',
      coaches: JSON.parse(coachesEl.dataset.coaches || '[]'),
      csrfToken: coachesEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(coachesEl))
    app.mount(coachesEl)
  }

  // Coach show
  const coachShowEl = document.getElementById('vue-coach-show')
  if (coachShowEl && !coachShowEl.__vue_app__) {
    const app = createApp(CoachShow, {
      signedIn: coachShowEl.dataset.signedIn === 'true',
      userName: coachShowEl.dataset.userName || '',
      userId: parseInt(coachShowEl.dataset.userId) || null,
      userAdmin: coachShowEl.dataset.userAdmin === 'true',
      coach: JSON.parse(coachShowEl.dataset.coach || '{}'),
      csrfToken: coachShowEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(coachShowEl))
    app.mount(coachShowEl)
  }
  // Split calculator
  const splitEl = document.getElementById('vue-split-calculator')
  if (splitEl && !splitEl.__vue_app__) {
    const app = createApp(SplitCalculator, {
      signedIn: splitEl.dataset.signedIn === 'true',
      userName: splitEl.dataset.userName || ''
    })
    app.use(createI18nInstance(splitEl))
    app.mount(splitEl)
  }
  // Privacy policy
  const privacyPolicyEl = document.getElementById('vue-privacy-policy')
  if (privacyPolicyEl && !privacyPolicyEl.__vue_app__) {
    const app = createApp(PrivacyPolicy, {
      signedIn: privacyPolicyEl.dataset.signedIn === 'true',
      userName: privacyPolicyEl.dataset.userName || ''
    })
    app.use(createI18nInstance(privacyPolicyEl))
    app.mount(privacyPolicyEl)
  }

  // Data deletion
  const dataDeletionEl = document.getElementById('vue-data-deletion')
  if (dataDeletionEl && !dataDeletionEl.__vue_app__) {
    const app = createApp(DataDeletion, {
      signedIn: dataDeletionEl.dataset.signedIn === 'true',
      userName: dataDeletionEl.dataset.userName || ''
    })
    app.use(createI18nInstance(dataDeletionEl))
    app.mount(dataDeletionEl)
  }

  // Cookie policy
  const cookiePolicyEl = document.getElementById('vue-cookie-policy')
  if (cookiePolicyEl && !cookiePolicyEl.__vue_app__) {
    const app = createApp(CookiePolicy, {
      signedIn: cookiePolicyEl.dataset.signedIn === 'true',
      userName: cookiePolicyEl.dataset.userName || ''
    })
    app.use(createI18nInstance(cookiePolicyEl))
    app.mount(cookiePolicyEl)
  }

  // User sidebar (global, on all pages when signed in)
  const sidebarEl = document.getElementById('vue-sidebar')
  if (sidebarEl && !sidebarEl.__vue_app__) {
    const app = createApp(UserSidebar, {
      signedIn: sidebarEl.dataset.signedIn === 'true',
      userId: parseInt(sidebarEl.dataset.userId) || null,
      csrfToken: sidebarEl.dataset.csrfToken || ''
    })
    app.use(createI18nInstance(sidebarEl))
    app.mount(sidebarEl)
  }
}

document.addEventListener('DOMContentLoaded', mountVueApps)
document.addEventListener('turbo:load', mountVueApps)
